import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'py-name-marking-text',
  templateUrl: './name-marking-text.component.html',
  styleUrls: ['./name-marking-text.component.scss'],
  standalone: false,
})
export class NameMarkingTextComponent implements OnInit {
  @Input() names: string[] = [];

  constructor() {}

  ngOnInit(): void {}
}
